export enum ScreenType {
    Desktop,
    SmallDesktop,
    Mobile
}